export const defaultCountry = (country) => {
    // Allow manual override of country
    try {
        const searchParams = new URLSearchParams(window.location.search);
        const defaultCountry = searchParams.get('default_country');
        // Return new country if override is present
        if (defaultCountry) return defaultCountry;
    } catch {
        // failed to parse params from URL, not really a failure
    }

    // Fall back to country-based eval
    switch (country) {
        case 'Costa Rica':
            return "CR"
        case 'United States of America':
            return "US";
        case 'Canada':
            return "CA";
        default:
            // Attempt to guess country by domain
            return window.location.host.includes('ctrlv.ca') ? "CA" : 'US';
    }
}